import * as React from "react";
import Input from "../../Input-new/Input";
import Checkbox from "../../CheckboxNew";
import Dropdown from "../../Dropdown/Dropdown";
import UploadFiles from "./UploadFiles";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import PsaForm from "./PsaForm";
import PsaAmendmentForm from "./PsaAmendmentForm";
import { isFieldLocked } from "../../../access-levels";
import { can } from "../../../access";
import LoanBids from "../../LoanBids/LoanBids";
import { showOnInNeg } from "../../LoanBids/visibility";

const items=[{
    label:'Contract',
    name:'IN_NEG_FILE_1'
    },{
    label:'Additional File 1',
    name:'IN_NEG_FILE_2'
    },{
    label:'Additional File 2',
    name:'IN_NEG_FILE_3'
    },{
    label:'Additional File 3',
    name:'IN_NEG_FILE_4'
    },{
    label:'Additional File 4',
    name:'IN_NEG_FILE_5'
    }];

const InNegotiationUnderContract = ({data, agentList, handleChangeInput, handleChangeDropdown, handleChangeFile, redirectToEscrowTracking, viewMode, deleted, locks, showLoanBids}) => {
    return (
        <div className="In-negotiation">
            <div className="In-negotiation_actions">
                {
                    // Marketing has no Escrow Tracking: the button would open "Not Authorized".
                    data.STATUS === 'Under Contract' && can('summit.escrow_tracking', 'view') &&
                    <button type='button'
                            className='button-new positive'
                            onClick={redirectToEscrowTracking}>
                        Escrow Tracking
                    </button>
                }
                <Checkbox
                    text='Peak Financing'
                    type={viewMode || isFieldLocked(locks, "HSC_FINANCING") ? "uncheckable" : "checkable"}
                    isSelected={data.HSC_FINANCING}
                    handleClick={handleChangeInput}
                    name='HSC_FINANCING'
                />
                <Checkbox
                    text='Other Financing'
                    type={viewMode || isFieldLocked(locks, "OTHER_FINANCING") ? "uncheckable" : "checkable"}
                    isSelected={data.OTHER_FINANCING}
                    handleClick={handleChangeInput}
                    name='OTHER_FINANCING'
                />
                {showLoanBids && showOnInNeg(data) && <LoanBids propertyId={data.ARCIMEDES_ROW_ID} propertyName={data.NAME}/>}
            </div>

            <div className="In-negotiation_column">
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="integer"
                    name="NEGOTIATION_PRICE"
                    label="Price"
                    value={data.NEGOTIATION_PRICE}
                    disabled={isFieldLocked(locks, "NEGOTIATION_PRICE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="percent"
                    name="NEGOTIATION_CAP_RATE"
                    label="Cap Rate - auto"
                    value={data.NEGOTIATION_CAP_RATE}
                    disabled={isFieldLocked(locks, "NEGOTIATION_CAP_RATE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="POTENTIAL_FEE"
                    label="SUMMIT Fee - Auto"
                    value={data.POTENTIAL_FEE}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="NEGOTIATION_PRICE_PER_SQFT"
                    label="PSF – auto"
                    value={data.NEGOTIATION_PRICE_PER_SQFT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                {/* <div className="dropdown-container">
                    <div class="view-mode-container ">
                        <label class="view-mode-label">Listing Agent</label>
                        <span class="">{data.LISTING_AGENT_1_FIRST_NAME} {data.LISTING_AGENT_1_LAST_NAME}</span>
                    </div>
                </div> */}
                <SelectTeam       
                    className="Listing-agent_column_item"
                    isFromProperty
                    value={data.TRANSACTION_COORDINATOR}
                    valueKey="TRANSACTION_COORDINATOR"
                    label="Transaction Coordinator"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    onlySummitEmployees={true}
                    transactionCoordinator={true}
                >   
                </SelectTeam>
            </div>
            <div className="In-negotiation_column">
            {
                data.HSC_FINANCING &&
                <Dropdown
                    className="In-negotiation_column_item"
                    data={data}
                    isFromProperty
                    optionsType='status-financing'
                    value={data.HSC_STATUS}
                    valueKey="HSC_STATUS"
                    label='PEAK Status'
                    disabled={isFieldLocked(locks, "HSC_STATUS")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            }
            <UploadFiles 
                classNames="In-negotiation_column_item"
                data={data}
                viewMode={viewMode} 
                deleted={deleted}
                handleChangeFile={handleChangeFile}
                maxFilesAmount={items.length}
                items={items}
                droppable
                />
            <div style={{ marginTop: 'auto' }}>
                <PsaForm
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <PsaAmendmentForm
                    data={data}
                    deleted={deleted}
                />
            </div>
            </div>
        </div>
    );
};

export default InNegotiationUnderContract;
